import { DateTime, DurationObjectUnits } from 'luxon';

import { Interval } from '../models/interval';

export class PhaseShiftHelper {
  public static toDuration(shift: number): DurationObjectUnits {
    return { minutes: shift };
  }

  public static shiftDate(date: DateTime, shift: number): DateTime {
    return shift ? date.plus(PhaseShiftHelper.toDuration(shift)) : date;
  }

  public static getSliceShift(interval: Interval, startDate: DateTime, endDate: DateTime): number {
    const diffMinutes = Math.round(endDate.diff(startDate, 'minutes').minutes);
    const half = diffMinutes / 2;
    let step: number;
    switch (interval) {
      case Interval.HOURS:
        step = 60;
        break;
      case Interval.DAYS:
      case Interval.MONTHS:
        step = 24 * 60;
        break;
      default:
        step = 3;
        break;
    }
    return Math.max(step, Math.round(half / step) * step);
  }

  public static fromCalendarDate(referenceCalendarDate: DateTime, pickedDate: DateTime): number {
    const diffMinutes = Math.round(pickedDate.diff(referenceCalendarDate, 'minutes').minutes);
    return Math.round(diffMinutes / 3) * 3;
  }
}
